import { FC } from 'react'
import { Card } from '@aptive-env/storybook'
import { AptiveIcon } from '@aptive-env/storybook'

type MapZoomControlProps = {
  onZoom: (type: 'in' | 'out') => void
}

export const MapZoomControl: FC<MapZoomControlProps> = ({
  onZoom
}) => {

  return (
    <Card
      className="flex flex-col justify-center gap-2"
    >
      <div
        className="w-[40px] h-[40px] shadow-med bg-ui-snow rounded-full flex items-center justify-center cursor-pointer"
        onClick={() => onZoom('in')}
      >
        <AptiveIcon className="h-[24px] stroke-ui-gray-600 fill-none" icon="plus" />
      </div>
      <div
        className="w-[40px] h-[40px] shadow-med bg-ui-snow rounded-full flex items-center justify-center cursor-pointer"
        onClick={() => onZoom('out')}
      >
        <AptiveIcon className="h-[24px] stroke-ui-gray-600 fill-none" icon="minus" />
      </div>
    </Card>
  )
}
